import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NewNavigationBar from '@surfline/quiver-react/dist/NewNavigationBar';
import FavoritesBar from '@surfline/quiver-react/dist/FavoritesBar';
import Notification from '@surfline/quiver-react/dist/Notification';
import CTA from '@surfline/quiver-react/dist/SurflinePageContainer/CTA';
import entitlementsPropType from '@surfline/quiver-react/dist/PropTypes/entitlementsPropType';
import favoritesPropType from '@surfline/quiver-react/dist/PropTypes/favoritesPropType';
import userPropType from '@surfline/quiver-react/dist/PropTypes/userPropType';
import settingsPropType from '@surfline/quiver-react/dist/PropTypes/settingsPropType';
import HeroAdUnit from './HeroAdUnit';
import AdBlock from './AdBlock';
import NotificationBarController from '../NotificationBarController';
import { HERO_AD_PLACEHOLDER, SL_WEB_MULTI_CAM_MODAL } from '../../../common/treatments';
import { heroAdConfigMap } from './heroAdConfig';
import config from '../../../config';

class Header extends Component {
  /**
   * Check if an alert should be displayed to the current user
   */
  getAccountAlert = () => {
    const { details: user } = this.props;
    return user && !user.isEmailVerified;
  };

  /**
   * Check if a warning should be displayed to the current user
   */
  getAccountWarning = () => {
    const { warnings } = this.props;
    return !!warnings.length;
  };

  /**
   * Check if the current user is a premium user and not being given premium by open house
   * @param {Array<string>} entitlements
   */
  isPremium = entitlements =>
    entitlements.indexOf('sl_premium') > -1 && entitlements.indexOf('sl_promotional') === -1;

  render() {
    const {
      settings,
      details: user,
      warnings,
      entitlements,
      favorites: {
        data: { favorites },
      },
      renderOptions,
      openHouse,
      features: {
        treatments: {
          [HERO_AD_PLACEHOLDER]: heroAdPlaceholder,
          [SL_WEB_MULTI_CAM_MODAL]: multiCamModalTreatment,
        },
      },
    } = this.props;

    const userEntitlements = entitlements ? entitlements.entitlements : [];
    const isPremium = this.isPremium(userEntitlements);
    const accountAlert = this.getAccountAlert();
    const accountWarning = this.getAccountWarning();
    const freeTrialEligible = entitlements && entitlements.promotions.indexOf('sl_free_trial') > -1;
    const largeFavoritesBar = !!renderOptions.largeFavoritesBar;
    const hideCTA = renderOptions.hideCTA === 'true';
    const hideNav = renderOptions.hideNav === 'true';

    const smallNotification = (
      <Notification type="small" level="information">
        <CTA className="quiver-notification__cta" ctaLocation="button top">
          START FREE TRIAL
        </CTA>
      </Notification>
    );

    return (
      <div>
        {!isPremium && renderOptions.showAdBlock === 'true' ? <AdBlock /> : null}
        {renderOptions.bannerAd !== 'false' && heroAdConfigMap[renderOptions.bannerAd] ? (
          <HeroAdUnit
            adType={renderOptions.bannerAd}
            user={user}
            entitlements={userEntitlements}
            qaFlag={renderOptions.qaFlag}
            placeholder={heroAdPlaceholder}
            articleId={renderOptions.bannerAdId}
          />
        ) : null}
        {!hideNav ? (
          <div>
            {!hideCTA ? (
              <NotificationBarController
                isPremium={isPremium}
                openHouse={openHouse}
                user={user}
                warnings={warnings}
              />
            ) : null}
            <NewNavigationBar
              user={user}
              favorites={favorites}
              settings={settings}
              smallNotification={smallNotification}
              hideCTA={hideCTA}
              entitlements={userEntitlements}
              serviceConfig={{
                serviceUrl: config.servicesURL,
              }}
              freeTrialEligible={freeTrialEligible}
              accountAlert={accountAlert}
              accountWarning={accountWarning}
            />
            <FavoritesBar
              settings={settings}
              favorites={favorites}
              user={user}
              large={largeFavoritesBar}
              multiCamModalEnabled={multiCamModalTreatment === 'hp_modal'}
            />
            <div id="backplane-header-open-house" />
          </div>
        ) : null}
      </div>
    );
  }
}

Header.propTypes = {
  entitlements: PropTypes.shape({
    entitlements: entitlementsPropType,
    promotions: PropTypes.array,
  }),
  favorites: PropTypes.shape({
    data: PropTypes.shape({
      favorites: favoritesPropType,
    }),
  }),
  details: userPropType,
  settings: settingsPropType,
  renderOptions: PropTypes.shape({
    largeFavoritesBar: PropTypes.string,
    qaFlag: PropTypes.string,
    bannerAd: PropTypes.string,
    hideCTA: PropTypes.oneOf(['true', 'false']),
    hideNav: PropTypes.oneOf(['true', 'false']),
    showAdBlock: PropTypes.oneOf(['true', 'false']),
    bannerAdId: PropTypes.string,
  }),
  openHouse: PropTypes.shape({
    active: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      banner: PropTypes.shape({
        copy: PropTypes.string.isRequired,
        creative: PropTypes.shape({
          '1x': PropTypes.string.isRequired,
          '2x': PropTypes.string,
          '3x': PropTypes.string,
        }).isRequired,
      }),
    }),
  }).isRequired,
  features: PropTypes.shape({
    treatments: PropTypes.shape({
      hero_ad_placeholder: PropTypes.string,
    }),
  }).isRequired,
  warnings: PropTypes.arrayOf(
    PropTypes.shape({
      subscriptionId: PropTypes.string,
      cardId: PropTypes.string,
      planId: PropTypes.string,
      type: PropTypes.string,
      status: PropTypes.string,
    })
  ),
};

Header.defaultProps = {
  details: null,
  settings: null,
  entitlements: { entitlements: [], promotions: [] },
  favorites: { data: { favorites: [] } },
  renderOptions: {
    largeFavoritesBar: null,
    qaFlag: null,
    bannerAd: 'false',
    hideCTA: 'false',
    hideNav: 'false',
  },
  warnings: [],
};

export default Header;
